import angular from 'angular';

import modelViewComponent from './model-view.component';
import ThreeJsView from './threejs-view.directive';


let modelViewModule = angular.module('modelView', [])

.component('modelView', modelViewComponent)
.directive('threeJsView', ThreeJsView)

.name;

export default modelViewModule;



// WEBPACK FOOTER //
// ./client/app/common/model-view/model-view.js